import React, { useEffect } from 'react';
import { useCategoryListQuery } from '../../../gql/hooks';
import { PageContainer, PageContent } from 'app/components/common';
import { LearningListController } from '../../common/learningListController';
import { InfoBanner } from '../../common/InfoBanner';
import { Navigation, Routes } from '../../../navigation';
import { IS_SEIKO_THEME } from '../../../branding';
import { SEIKO_DEFAULT_CATEGORY_BANNER_PLACEHOLDER_IMAGE } from '../../../const';

export const CategoryRoutingPage = ( ) => {

    const { data: validCategories, loading } = useCategoryListQuery();

    const bannerData = 
        IS_SEIKO_THEME ? { backgroundSrc: SEIKO_DEFAULT_CATEGORY_BANNER_PLACEHOLDER_IMAGE } : {};

    useEffect( () => {
        if ( !validCategories || loading ) {return;}

        if ( validCategories?.length == 0 ) {
            Navigation.push( Routes.Learning.buildPath() );
        } else {
            const catId = validCategories[ 0 ].node.id;
            if ( !catId ) {
                Navigation.push( Routes.Learning.buildPath() );
            }
            Navigation.push( Routes.CategoryDetails.buildPath( catId ) );
        }

    }, [ validCategories, loading ]  );

    return (
        <PageContent className="page-category-details">
           
           <PageContainer className="category-details-banner-container">
                <InfoBanner isLoading={ true } { ...bannerData } />

                <LearningListController
                    loading={ true }
                />
            </PageContainer>
        </PageContent>
    );
};
